/* eslint-disable react/jsx-no-useless-fragment */

import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import style from './start-virtual-visits.module.scss';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputAdornment,
  Link,
  TextField,
  Typography
} from '@mui/material';

type IStartVirtualVisitProps = {
  message: string;
  readonly?: boolean;

  open: boolean;
  onCancel?: () => void;
  onStart: (message: string) => void;
};

export const StartVirtualVisits: React.FC<IStartVirtualVisitProps> = (props) => {
  const [open, setOpen] = useState(props.open);
  const [value, setValue] = useState<string>(props.message);

  const inputLabel = props.readonly ? 'Shareable Link for Virtual Visits' : 'Text Message';
  const inputWidth = props.readonly ? 230 : 110;
  const endAdornment = props.readonly && (
    <CopyToClipboard text={value}>
      <Link style={{ width: '100px' }}>Copy Link</Link>
    </CopyToClipboard>
  );

  return (
    <Dialog
      open={open}
      className={style['start-virtual-visits']}
      PaperProps={{ sx: { backgroundColor: 'white', padding: '20px' } }}
    >
      <DialogTitle>
        <Typography variant={'h6'}>Start a Virtual Visit</Typography>
      </DialogTitle>
      {!props.readonly && (
        <DialogContent>
          <Typography variant={'body1'}>
            Customize the text message that will be sent to your patient when you start the Virtual Visit.
          </Typography>
        </DialogContent>
      )}
      <div className={style['text-message']}>
        <FormControl fullWidth variant="outlined">
          <TextField
            label={inputLabel}
            InputProps={{
              readOnly: props.readonly,
              startAdornment: (
                <InputAdornment position="start">
                  <></>
                </InputAdornment>
              ),
              endAdornment: <InputAdornment position="end">{endAdornment}</InputAdornment>
            }}
            multiline
            value={value}
            onChange={(e) => setValue(e.currentTarget.value)}
          />
        </FormControl>
      </div>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          disableElevation
          onClick={() => {
            setOpen(false);
            if (props.onCancel) {
              props.onCancel();
            }
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={() => {
            setOpen(false);
            props.onStart(value);
          }}
        >
          Start virtual visit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
